import { render, staticRenderFns } from "./RuleEditor.vue?vue&type=template&id=a9453ddc"
import script from "./RuleEditor.vue?vue&type=script&lang=ts"
export * from "./RuleEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports